import {
    PRODUCT_COMPARE_REQUEST,
    PRODUCT_COMPARE_SUCCESS,
    PRODUCT_COMPARE_FAILURE,
    

} from "../constants/ActionTypes";

const initialState = {
    loading: false,
    compareDetail: [],
    error: null,
};

export default function productCompareReducer(state = initialState, action) {
    // 
    switch (action.type) {
        case PRODUCT_COMPARE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case PRODUCT_COMPARE_SUCCESS: 
        
            return {
                ...state,
                // always replacing data
                
                compareDetail: action.data.product_details,
                loading: false,
                // if adding data
                // data: [...state.data, action.data]
            };
        case PRODUCT_COMPARE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };

          
        default:
            return state;
    }
}
